import DataGrid2 from '../../..';

export async function removeRow(this: DataGrid2, key: any) {
	await this.rowChangeAction({
		type: 'remove',
		key
	});
}
